// extracted by mini-css-extract-plugin
module.exports = {"section":"_2NBXjQDebzSEih_VYn5t_4","inner":"_3EYLYYE_adKIBBS4B22dG0","body":"_2opmnDZmtjdwNjRsa3_Noy"};